import * as types from '../constants/actionTypes';
import initialState from './initialState';
import update from 'immutability-helper/index';
import _ from 'lodash';

export default function activitiesReducer(
    state = initialState.activities,
    action,
) {
    switch (action.type) {
        case types.LOAD_ACTIVITIES_SUCCESS: {
            return action.activities;
        }
        case types.SAVE_ACTIVITY_SUCCESS: {
            const { activity } = action;
            const index = _.findIndex(state, { id: activity.id });
            if (index !== -1) {
                const activities = update(state, {
                    [index]: {
                        $set: Object.assign({}, state[index], activity),
                    },
                });
                return activities;
            }
            return state;
        }
        default:
            return state;
    }
}
